import { TFunction } from 'i18next'
import { QUERY_VALUES } from 'lib/util/routing'

enum RecordedWebinarSort {
  Recent = 'recent',
  Popular = 'popular',
  Title = 'title',
}
export default RecordedWebinarSort

export function getDisplayNames(t: TFunction) {
  return {
    [RecordedWebinarSort.Recent]: t('home.recordedWebinarsSection.sort.recent'),
    [RecordedWebinarSort.Popular]: t('home.recordedWebinarsSection.sort.popular'),
    [RecordedWebinarSort.Title]: t('home.recordedWebinarsSection.sort.title')
  }
}

const recordedWebinarSortByQueryValue = {
  [QUERY_VALUES.recent]: RecordedWebinarSort.Recent,
  [QUERY_VALUES.popular]: RecordedWebinarSort.Popular,
  [QUERY_VALUES.title]: RecordedWebinarSort.Title
}

export function getRecordedWebinarSortByQueryValue(queryValue: string) {
  return recordedWebinarSortByQueryValue[queryValue] || RecordedWebinarSort.Title
}
